import { t } from "@/i18n-js/instance";
import { ModalCloseButton } from "@circle-react-shared/ModalsV2/FullScreenModal/components/ModalCloseButton";
import { SelectRadioGroup } from "@circle-react-uikit/SelectRadioGroup";
import { Typography } from "@circle-react-uikit/Typography";
import type { TabOptions } from "./index";

interface ModalHeaderProps {
  selectedTab: string;
  setSelectedTab: (tab: TabOptions) => void;
  onClose: () => void;
}

const isValidTab = (tab: string): tab is TabOptions =>
  ["banner", "options"].includes(tab);

export const ModalHeader = ({
  selectedTab,
  setSelectedTab,
  onClose,
}: ModalHeaderProps) => {
  const onChangeHandler = (tab: string) => {
    if (!isValidTab(tab)) {
      return;
    }
    setSelectedTab(tab);
  };

  return (
    <div className="flex w-full justify-start">
      <div className="flex w-2/3 items-center md:w-1/3">
        <Typography.TitleSm weight="semibold" color="text-darkest">
          {t("courses.directory.options_modal.title")}
        </Typography.TitleSm>
      </div>
      <div className="hidden w-1/3 items-center justify-center md:flex">
        <SelectRadioGroup
          value={selectedTab}
          onChange={onChangeHandler}
          options={[
            {
              value: "banner",
              label: t("courses.directory.options_menu.banner"),
            },
            {
              value: "options",
              label: t("courses.directory.options_menu.options"),
            },
          ]}
        />
      </div>
      <div className="flex w-1/3 items-center justify-end md:hidden">
        <ModalCloseButton onClick={onClose} />
      </div>
    </div>
  );
};
